var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 34C26.6127 34 34 26.6127 34 17.5C34 8.3873 26.6127 1 17.5 1C8.3873 1 1 8.3873 1 17.5C1 26.6127 8.3873 34 17.5 34Z",
    fill: "#5A5C5E",
    stroke: "#FAF6F6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89845 14.1553C10.9586 13.5554 11.8775 13.6904 12.6541 14.5584L12.6904 14.62C13.2077 15.4982 16.4811 21.8915 17.1728 24.7396C17.1431 25.195 16.8321 25.5897 16.242 25.9236L15.2394 26.4909C14.3824 26.368 13.7491 25.9626 13.3455 25.2775C11.623 21.5651 8.54736 14.9197 9.45631 14.4054L9.89845 14.1553Z",
    fill: "#FAF6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4673 25.7648C14.3578 25.2578 14.0984 24.1174 14.689 22.3436L14.7392 22.2381C15.4552 20.7332 20.1416 11.8745 22.8948 8.06884C23.3967 7.61257 23.9569 7.5267 24.5745 7.8089L25.6237 8.2884C25.8675 9.35173 25.7113 10.4722 25.1532 11.6451C21.9243 17.498 16.8812 26.4109 15.93 25.9763L15.4673 25.7648Z",
    fill: "#FAF6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.3942aadbfb579fd934124956838a64a5.svg";
export { ForwardRef as ReactComponent };